/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefit_Travel_DescInputs */

const en_home_benefit_travel_desc = /** @type {(inputs: Home_Benefit_Travel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destination guides, alerts, safety tips, and educational content to keep you informed.`)
};

const fr_home_benefit_travel_desc = /** @type {(inputs: Home_Benefit_Travel_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides de destination, alertes, conseils de sécurité et contenu éducatif pour vous tenir informé.`)
};

/**
* | output |
* | --- |
* | "Destination guides, alerts, safety tips, and educational content to keep you informed." |
*
* @param {Home_Benefit_Travel_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefit_travel_desc = /** @type {((inputs?: Home_Benefit_Travel_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefit_Travel_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefit_travel_desc(inputs)
	return fr_home_benefit_travel_desc(inputs)
});